import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import {
  ActivatedRoute,
  NavigationBehaviorOptions,
  NavigationEnd,
  Router,
} from '@angular/router';
import { Campagne } from '@core/models/campagne.model';
import {
  AdressesDestinatairesService,
  AnnonceurService,
  CampagneDetailsService,
  GlobalDataService
} from '@core/services';
import { PersonalisationService } from '@core/services/personalisation.service';
import { CampagneService } from '@core/services/campagne.service';
import { EstimationService } from '@core/services/estimation.service';
import { Subject, Subscription, forkJoin, from, takeUntil } from 'rxjs';
@Component({
  selector: 'app-campagne-details',
  templateUrl: './campagne-details.component.html',
  styleUrls: ['./campagne-details.component.scss'],
})
export class CampagneDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  titre = 'Conception de la campagne courrier';
  Campagne!: Campagne;
  isLoaded = false;
  isLinear: boolean = true;
  isEditable = true;
  MAX_STEP = 7;
  showButtonRetour = false;

  selectedIndex: number = 0;

  step: number = 0;
  page: number = 0;

  @ViewChild(MatStepper) stepper!: MatStepper;

  navigationSubscription: Subscription;
  activeRouteSubscription: Subscription;
  completedStepsSubscription: Subscription;

  navigationOption: NavigationBehaviorOptions = { state: {} };

  campaignName: string;
  private destroy$ = new Subject<void>();

  constructor(
    public _GlobalDataService: GlobalDataService,
    private router: Router,
    public _AnnonceurService: AnnonceurService,
    private activeRoute: ActivatedRoute,
    private _CampagneService: CampagneService,
    private _CampagneDetailsService: CampagneDetailsService,
    private _EstimationService: EstimationService,
    private elementRef: ElementRef,
    private _AdressesDestinatairesService: AdressesDestinatairesService,
    private injector: Injector
  ) {
    this.activeRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
      this._GlobalDataService.objectParams = params; // Print the parameter to the console.
    });

    // this.activeRouteSubscription =  this.activeRoute.paramMap.subscribe((params: ParamMap) => {
    //   this.IdCampagne = <string>params.get('IdCampagne');
    // });

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        // this.changeStepperStyle();
      }
    });

    this.completedStepsSubscription = this._GlobalDataService.completedStepsEvt
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.changeStepperStyle();
      });
  }

  ngOnInit() {
    //init pas de change!
    //identification campagne
    this._GlobalDataService.referenceDocHelp = '#new_campaign_step1';
    this.restoreNewCampaignDraftOnRefresh();
    const isHydratingOnRefresh = this.hydrateCampaignOnRefresh();
    const isNewCampaignRoute = this.isNewCampaignRoute();
    if (isNewCampaignRoute) {
      this._CampagneDetailsService.gotoDetailCampagne();
    }
    this.restorePersistedStep();
    this._GlobalDataService.stepIndex = this.selectedIndex;
    if (!isHydratingOnRefresh && !isNewCampaignRoute) {
      this.isLoaded = true;
      this._GlobalDataService.isLoaded = true;
    }
  }

  ngAfterViewInit() {
    if (this.stepper) {
      this._GlobalDataService.stepper = this.stepper;
      this.stepper._getIndicatorType = () => 'number';
      this.restorePersistedStep();
      this._GlobalDataService.checkStepCompletion();
      this.changeStepperStyle();
    }
  }

  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    this.persistCampaignDraftOnRefresh();
  }
  navigatetoErrorPage(error: any) {
    //une erreur est survenue => redirection page erreur
    console.error('CampagneDetailsComponent : ErrorCurrentCampagne', error);
    this.router.navigate(['/erreur'], {
      queryParams: this._GlobalDataService.objectParams,
      queryParamsHandling: 'merge',
    });
    this.isLoaded = true;
  }

  showTooltip(event: any) {
  }

  SuccessCurrentCampagne(campagne) {
    if (campagne?.IdCampagne) {
      const NomCampagne = this._GlobalDataService.Campagne.NomCampagne;
      const Description = this._GlobalDataService.Campagne.Description;
      const BonDeCommande = this._GlobalDataService.Campagne.BonDeCommande;

      //affecter la campagne reçu

      this._GlobalDataService.Campagne = {
        ...campagne,
        ...this._GlobalDataService.Campagne,
        IdCampagne: campagne.IdCampagne,
      };

      this._GlobalDataService.Campagne.NomCampagne = NomCampagne;
      this._GlobalDataService.Campagne.Description = Description;
      this._GlobalDataService.Campagne.BonDeCommande = BonDeCommande;

      if (
        typeof this._GlobalDataService.Campagne.EmailNotification == 'undefined'
      )
        this._GlobalDataService.Campagne.EmailNotification = '';

      this.restorePersistedStep();
    }
  }

  changeStepperStyle() {
    if (!this._GlobalDataService.CampagneExt?.completedSteps) {
      return;
    }
    this.elementRef.nativeElement
      .querySelectorAll('mat-step-header')
      .forEach((item: { classList: { remove: (arg0: string) => void } }) => {
        item.classList.remove('step-completed');
      });

    this.elementRef.nativeElement
      .querySelectorAll('.mat-stepper-horizontal-line')
      .forEach((item: { classList: { remove: (arg0: string) => void } }) => {
        item.classList.remove('step-completed');
      });

    this._GlobalDataService.CampagneExt.completedSteps.forEach((stepIndex) => {
      // let elem = this.elementRef.nativeElement.querySelector(`mat-step-header[aria-posinset="${stepIndex}"] .mat-step-icon`);
      let elem = this.elementRef.nativeElement.querySelector(
        `mat-step-header[aria-posinset="${stepIndex}"]`
      );

      if (!elem) return;
      elem.classList.add('step-completed');
      elem.nextSibling.nextSibling.classList.add('step-completed');
    });
  }

  selectionChange(event: any) {
    if (!this._GlobalDataService.Campagne || !this._GlobalDataService.CampagneExt) {
      return;
    }

    // ATA@20230403 - Security enhancements
    if (
      this._GlobalDataService.isTokenExpired(
        this._GlobalDataService.getJwtoken()
      )
    ) {
      this._GlobalDataService.refreshToken();
    }

    if (this._GlobalDataService.Campagne.NomCampagne === '') {
      this._GlobalDataService.alert(
        'Le nom de la campagne est obligatoire et doit-être unique. Merci de renseigner un nouveau nom de campagne'
      );
      return;
    }

    this.selectedIndex = event.selectedIndex;

    this.persistDirtyCampaign();
    
    // Personalisation Champs Fusion automatic save in stepper
    if (this._GlobalDataService.CONTEXT === 'ELOQUA' && this._GlobalDataService.stepIndex === 3) {
      const personalisationService = this.injector.get(PersonalisationService);
      personalisationService.setChampFusionType();
      this._GlobalDataService.CampagneExt.ChampsFusion = 
      personalisationService.selectedChampsFusion.concat( this._AdressesDestinatairesService.selectedChampsFusion);
      this._GlobalDataService
        .saveAll(this._GlobalDataService.Campagne, true)
        .subscribe({
          complete: () => {},
          error: (e) => {
            console.error(e.error.message);
            this._GlobalDataService.openSnackBarInfo(e.error.message);
          },
        });
    }

    this._GlobalDataService.stepIndex = event.selectedIndex;
    this.persistCurrentStep(event.selectedIndex);

    if (this._GlobalDataService.Campagne.volume) {
      this._GlobalDataService.formEstimate
        .get('volume')
        .setValue(this._GlobalDataService.Campagne.volume, {
          emitEvent: false,
        });
    }

    // Fil d'Ariane
    this._GlobalDataService.checkStepCompletion();
    this.changeStepperStyle();

    switch (event.selectedIndex) {
      case 0:
        //identification campagne
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step1';
        break;
      case 1:
        // Typologie
        this._GlobalDataService.Campagne.VisualisationStep2 = true;
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step3';

        break;
      case 2:
        // Créations
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step6';
        break;
      case 3:
        // Personnalisation
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step6';
        break;
      case 4:
        // Planification
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step7';
        break;
      case 5:
        // Adresses
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step8';
        break;
      case 6:
        //Récapitulatif
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step10';
        if (this._GlobalDataService.Campagne.volume) {
          this.estimate();
        }
        break;
      default:
        //identification campagne
        this._GlobalDataService.referenceDocHelp = '#new_campaign_step1';
        break;
    }
  }

  private persistDirtyCampaign(): void {
    if (!this._GlobalDataService.Campagne.isDirty) {
      return;
    }

    if (this._GlobalDataService.Campagne.IdCampagne) {
      this.updateCurrentCampaign();
      return;
    }

    if (!this._GlobalDataService.isStandaloneContext()) {
      this._GlobalDataService.saveCampaignDraft();
      return;
    }

    this._CampagneService.getCurrentCampagne()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (!response?.campagne?.IdCampagne) {
            this._GlobalDataService.saveCampaignDraft();
            return;
          }

          this.SuccessCurrentCampagne(response.campagne);
          this.updateCurrentCampaign();
        },
        error: (error) => {
          console.error('Impossible de récupérer la campagne courante.', error);
          this._GlobalDataService.saveCampaignDraft();
        },
      });
  }

  private updateCurrentCampaign(): void {
    if (!this._GlobalDataService.Campagne.IdCampagne) {
      return;
    }

    this._CampagneService.put(this._GlobalDataService.Campagne)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this._GlobalDataService.checkStepCompletion();
          this.changeStepperStyle();
          this._GlobalDataService.Campagne.isDirty = false;
          this._GlobalDataService.saveCampaignDraft();
        },
        error: (error) => {
          const message = error?.error?.message || 'Impossible de mettre à jour la campagne.';
          console.error(message, error);
          this._GlobalDataService.openSnackBarInfo(message);
        },
      });
  }

  /**
   * Estimate price.
   * Product, delivery priority and volume are necessary to estimate.
   */
  estimate() {
    if (!this._GlobalDataService.CampagneExt.Produit) {
      this._GlobalDataService.alert(
        "Veuillez renseigner la typologie souhaitée afin d'utiliser l'estimation tarifaire."
      );
      return;
    }
    if (!this._GlobalDataService.Campagne.CodeVitesse) {
      this._GlobalDataService.alert(
        "Veuillez renseigner le type de vitesse souhaitée afin d'utiliser l'estimation tarifaire."
      );
      return;
    }
    if (!this._GlobalDataService.Campagne.volume) {
      this._GlobalDataService.alert(
        "Veuillez renseigner le volume souhaitée afin d'utiliser l'estimation tarifaire."
      );
      return;
    }
    let request = this._GlobalDataService.getEstimationRequest();
    if (request) {
      this._EstimationService.put(request)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
        (response) => this.estimateRresponseHandler(response),
        (error) => this.estimateErrorHandler(error)
      );
    }
  }

  estimateRresponseHandler(response: any) {
    if (
      typeof response.response === 'object' &&
      response.response.status === 'SUCCESS'
    ) {
      this._GlobalDataService.Campagne.unitAmountWithoutTax =
        response.chargeList.length > 0
          ? response.chargeList[0].unitAmountWithoutTax
          : '';
      this._GlobalDataService.Campagne.amountWithoutTax =
        response.chargeList.length > 0
          ? response.chargeList[0].amountWithoutTax
          : '';
      this._GlobalDataService.Campagne.showInfo = true;
      this._GlobalDataService.Campagne.showRefresh = true;
      this._GlobalDataService.Campagne.showunitAmountWithoutTax = true;
      this._GlobalDataService.Campagne.showamountWithoutTax = true;
    } else if (response.status === 500) {
      this._GlobalDataService.alert(
        "Le serveur d'estimation tarifaire est indisponible."
      );
    } else {
      this._GlobalDataService.Campagne.unitAmountWithoutTax = '';
      this._GlobalDataService.Campagne.amountWithoutTax = '';
      this._GlobalDataService.alert(
        "Une erreur est survenue . Merci de relancer l'estimation tarifaire.",
        response.response.errorMessage
      );
    }
  }

  estimateErrorHandler(error: any) {
  }

  submit() {
    //call API
    this.stepper.next();
  }

  ngOnDestroy() {
    this.persistCampaignDraftOnRefresh();
    this.destroy$.next();
    this.destroy$.complete();
    if (this.navigationSubscription) this.navigationSubscription.unsubscribe();
    if (this.activeRouteSubscription)
      this.activeRouteSubscription.unsubscribe();
  }

  public campaignNameChange(name: string): void {
    this.campaignName = name;
  }
  private getCurrentCampaignId(): string | null {
    if (this.isNewCampaignRoute()) {
      return null;
    }

    return (
      this.activeRoute.snapshot.paramMap.get('IdCampagne') ||
      this._GlobalDataService.Campagne?.IdCampagne ||
      null
    );
  }
  private restorePersistedStep(): void {
    const idCampagne = this.getCurrentCampaignId();
    const savedStep = this._GlobalDataService.getSavedCampaignStep(idCampagne);
    if (savedStep === null) {
      return;
    }
    const safeStep = Math.max(0, Math.min(savedStep, this.MAX_STEP - 1));
    this.selectedIndex = safeStep;
    this._GlobalDataService.stepIndex = safeStep;
    if (this.stepper && this.stepper.selectedIndex !== safeStep) {
      this.stepper.selectedIndex = safeStep;
    }
  }
  private persistCurrentStep(stepIndex: number): void {
    const idCampagne = this.getCurrentCampaignId();
    this._GlobalDataService.saveCampaignStep(idCampagne, stepIndex);
  }
  private restoreNewCampaignDraftOnRefresh(): void {
    const routeCampaignId = this.activeRoute.snapshot.paramMap.get('IdCampagne');
    const isReload = this.isPageReload();
    if (!isReload) {
      return;
    }

    // If there's an Id in the route we let the hydrate flow handle it
    if (routeCampaignId) {
      return;
    }

    // Detect navview outlet or route paths that correspond to new-campaign
    const navViewPath = this.router.parseUrl(this.router.url).root.children['navview']?.segments?.[0]?.path;
    const currentRoutePath = this.activeRoute.snapshot.routeConfig?.path;

    const isNewCampaignView = navViewPath === 'nouvelle-campagne' || navViewPath === 'campagne-details' || currentRoutePath === 'nouvelle-campagne';
    if (!isNewCampaignView) {
      return;
    }

    // CampagneExt is applied by gotoDetailCampagne immediately before initialization.
    this._GlobalDataService.applyCampaignDraft(null);
  }
  private hydrateCampaignOnRefresh(): boolean {
    const routeCampaignId = this.activeRoute.snapshot.paramMap.get('IdCampagne');
    if (!routeCampaignId) {
      return false;
    }
    if (
      this._GlobalDataService.Campagne?.IdCampagne === routeCampaignId &&
      this._GlobalDataService.isLoaded
    ) {
      return false;
    }
    this.isLoaded = false;
    this._GlobalDataService.isLoaded = false;
    forkJoin({
      campagneRes: this._CampagneService.getCurrentCampagne(),
      _statut: from(this._GlobalDataService.getStatutMapping()),
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({ campagneRes: res }) => {
          if (!res?.campagne) {
            this.navigatetoErrorPage(res);
            return;
          }
          this._GlobalDataService.Campagne = res.campagne;
          this._GlobalDataService.applyCampaignDraft(routeCampaignId);
          this._CampagneDetailsService.gotoDetailCampagne();
          this.restorePersistedStep();
        },
        error: (error) => this.navigatetoErrorPage(error),
      });
    return true;
  }
  private persistCampaignDraftOnRefresh(): void {
    if (!this._GlobalDataService?.Campagne) {
      return;
    }
    const persistenceId = this.getCurrentCampaignId();
    const currentStep = Number.isInteger(this._GlobalDataService.stepIndex)
      ? this._GlobalDataService.stepIndex
      : this.selectedIndex;

    this._GlobalDataService.saveCampaignStep(persistenceId, currentStep);
    this._GlobalDataService.saveCampaignDraft(
      this._GlobalDataService.Campagne,
      this._GlobalDataService.CampagneExt,
      persistenceId,
    );
    const campaignId = this._GlobalDataService.Campagne.IdCampagne;
    if (campaignId) {
      this._GlobalDataService.rememberCurrentCampaignNavigation(
        'campagne-details',
        campaignId,
      );
      if (persistenceId !== campaignId) {
        this._GlobalDataService.saveCampaignStep(campaignId, currentStep);
        this._GlobalDataService.saveCampaignDraft(
          this._GlobalDataService.Campagne,
          this._GlobalDataService.CampagneExt,
          campaignId,
        );
      }
    }
  }
  private isPageReload(): boolean {
    const navigationEntries = window.performance?.getEntriesByType?.('navigation') as PerformanceNavigationTiming[];
    return navigationEntries?.[0]?.type === 'reload';
  }
  private isNewCampaignRoute(): boolean {
    const navViewSegments = this.router.parseUrl(this.router.url).root.children['navview']?.segments || [];
    const navViewPath = navViewSegments[0]?.path;
    const routePath = this.activeRoute.snapshot.routeConfig?.path;
    return navViewPath === 'nouvelle-campagne' ||
      (navViewPath === 'campagne-details' && navViewSegments.length === 1) ||
      routePath === 'nouvelle-campagne' ||
      routePath === 'campagne-details';
  }
}
  

